import PropTypes from 'prop-types'
import React from 'react'

import DynamicImage from 'components/DynamicImage'
import Icon from 'components/Icon'
import RenderInView from 'components/RenderInView'
import { LocalizationContext } from 'contexts/Localization'
import { H2, Text } from 'styles/components/typography'

import {
  ContentBox,
  Wrapper,
  IconBox,
  ImageBox,
  Spacer,
  HeaderBox,
} from './styles'

const WAboutSpecializedReport = ({ data }) => {
  const { cdnPaths } = React.useContext(LocalizationContext)

  return (
    <Wrapper>
      <ImageBox>
        <RenderInView>
          <DynamicImage
            imageSizes={{ xs: 384, md: 768, lg: 1280 }}
            image={`${cdnPaths.wgs_about}/specialized_report/hands-v1`}
            alt="specialized_report"
            imageType="png"
            namesByBreakpoints
          />
        </RenderInView>
      </ImageBox>
      <Spacer />
      <ContentBox>
        <IconBox>
          <Icon id="gender" color="black" />
        </IconBox>
        <HeaderBox>
          <H2 as={'h3'} dangerouslySetInnerHTML={{ __html: data.title }} />
        </HeaderBox>
        <Text dangerouslySetInnerHTML={{ __html: data.description }} />
      </ContentBox>
    </Wrapper>
  )
}

WAboutSpecializedReport.propTypes = {
  data: PropTypes.object.isRequired,
}

export default WAboutSpecializedReport
